<template>
    <div class="contacts">
        <b-container>
                <b-row align-h="center">
                    <b-col cols="12" lg="6">
                        <h1 v-t="'findLisbon'"></h1>
                    </b-col>
                </b-row>
                <b-row align-h="center" class="mt-2">
                    <b-col lg="3" md="12"> <b-button variant="primary" href="tel:210312807">210 312 807</b-button> </b-col>
                    <b-col lg="3" md="12"> <b-button variant="primary" href="tel:919878409">919 878 409</b-button> </b-col>
                    <b-col lg="3" md="12"> <b-button variant="primary" class="is--email" href="mailto:info@lismarketing.pt">info@lismarketing.pt</b-button> </b-col>
                </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

.contacts {
    background-image: url("../../../assets/images/cabo-da-roca.jpg");
    height: 600px;
    background-size: cover;

    padding: 110px 0;

    h1 {
        margin-bottom: 10px;
    }

    .btn {
        margin: 20px 0;

        &:before {
            content: url("../../../assets/images/icons/phone.svg");
            background: white;
            height: 1.25rem;
            width: 1.25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            margin-right: 0.625rem;

            padding-bottom: 1px;
            padding-left: 1px;
        }

        &.is--email {
            &::before {
                content: url("../../../assets/images/icons/envelope.svg");
            }
        }
    }
}

</style>